import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';

const NoSidebarLayout = () => {
    return (
        <div className="content w-100 p-3">
            <Outlet />
        </div>
    );
};

export default NoSidebarLayout;
